"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantTierEnum = void 0;
var TenantTierEnum;
(function (TenantTierEnum) {
    TenantTierEnum["FREE"] = "free";
    TenantTierEnum["TIER_1"] = "tier_1";
    TenantTierEnum["TIER_2"] = "tier_2";
})(TenantTierEnum || (exports.TenantTierEnum = TenantTierEnum = {}));
